import React, { useState } from 'react';
import { Modal, Button } from 'react-bootstrap';

import { channelProductApi } from 'api';

const ProductUnlinkModal = ({ show, onHide, product, onSuccess }) => {
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);

  const handleClose = () => {
    setError(null);
    onHide();
  };

  const handleUnlink = async () => {
    if (!product) return;

    setIsLoading(true);

    try {
      await channelProductApi.unlinkProduct(product.id);

      // fetch table data
      onSuccess?.();
      handleClose();
    } catch (error) {
      setError(error.message);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Modal show={show} onHide={handleClose}>
      <Modal.Header closeButton>
        <Modal.Title>Confirm Unlink</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p>Are you sure you want to unlink this product?</p>
        {error && <div className="alert alert-danger mt-3">{error}</div>}
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={handleClose} disabled={isLoading}>
          Cancel
        </Button>
        <Button variant="danger" onClick={handleUnlink} disabled={isLoading}>
          {isLoading ? 'Unlinking...' : 'Unlink'}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ProductUnlinkModal;
